import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import React from "react";
import OrderColumn from "./OrderColumn";
import DeleteFilterTable from "../../microComponents/tablePages/filter/DeleteFilterTable";
import UseSetParams from "../../microComponents/tablePages/filter/UseSetParams";
import IconBtn from "../../microComponents/elements/IconBtn";
import {IoMdAdd} from "react-icons/io";
import {Link, useNavigate} from "react-router-dom";
import ExpandedOrder from "./ExpandedOrder";
import ShowSearchBtn from "../../microComponents/tablePages/ShowSearchBtn";
import CollapseBox from "../../microComponents/tablePages/CollapseBox";
import TopSearchOrder from "./TopSearchOrder";
import {useSelector} from "react-redux";


const PalletRebuild = () => {
    const [columns] = OrderColumn();
    const [, handleDeleteParams] = UseSetParams();
    const showSearchBox = useSelector((state) => state.TableRedux.showSearchBox);
    const navigate = useNavigate();

    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>حواله</Title>
                    <div className='flex gap-2 items-center'><Link to='/order/create'><IconBtn color='greenIconBtn'
                                                                                               TooltipText='اضافه کردن حواله جدید'>
                        <IoMdAdd size={20} color='white'/>
                    </IconBtn></Link>
                        <DeleteFilterTable onClick={handleDeleteParams}/>
                        {/*<CreateEditOrder  />*/}


                        <ShowSearchBtn/>
                    </div>


                </div>
                <div className='searchBox p-0'>
                    <CollapseBox activeKey={showSearchBox ? ['1'] : null} items={[{
                        showArrow: false, headerPadding: '1px', className: 'bg-white border-none',
                        key: '1', children: <TopSearchOrder/>,
                    }]}/>

                </div>
            </ComponentCard> <ComponentCard>
            {/*<CheckPermissionPage module='batch'>*/}

            <CreatorTable columns={columns} listAddress='order' rowKey='orderNumber'
                          expandable={{
                              expandedRowRender: (row) => (

                                  <ExpandedOrder item={row}/>

                              ),
                              // rowExpandable: (record) => record.name !== 'Not Expandable',
                          }}
                          onDoubleClickRowHandler={(row) => {
                              navigate(`/order/${row.orderNumber}`);
                          }}

            />

            {/*</CheckPermissionPage>*/}
        </ComponentCard></div>
    );
};


export default PalletRebuild;